import { render } from "./CrearDiagnostico.vue?vue&type=template&id=1a0a01bf&scoped=true"
import script from "./CrearDiagnostico.vue?vue&type=script&lang=js"
export * from "./CrearDiagnostico.vue?vue&type=script&lang=js"

import "./CrearDiagnostico.vue?vue&type=style&index=0&id=1a0a01bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0a01bf"]])

export default __exports__